import { render, staticRenderFns } from "./safe-password.vue?vue&type=template&id=f4a846b8&"
import script from "./safe-password.vue?vue&type=script&lang=ts&"
export * from "./safe-password.vue?vue&type=script&lang=ts&"
import style0 from "./safe-password.vue?vue&type=style&index=0&id=f4a846b8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports